import { render, staticRenderFns } from "./TablaContenido.vue?vue&type=template&id=0b00d8c5"
import script from "./TablaContenido.vue?vue&type=script&lang=js"
export * from "./TablaContenido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports